module.exports = __webpack_public_path__ + "img/GB2.e8116de9.webp";